<template>
  <div class="tm-calendar">
    <tm-skeleton-filters />

    <tm-scrollbar allow-scroll-x>
      <div class="tm-calendar__body">
        <tm-calendar-grid class="tm-calendar-monthly">
          <tm-calendar-body>
            <tm-calendar-row
              v-for="i in 5"
              :key="`row-${i}`"
              class="tm-calendar-monthly-row"
            >
              <tm-calendar-cell
                v-for="j in 7"
                :key="`cell-${j}`"
                class="tm-calendar-monthly-row__cell"
              >
                <tm-calendar-month-day-layout class="flex-grow-1">
                  <tm-skeleton
                    v-if="randomNumber(0, 3) === 1"
                    type="QChip"
                    width="100px"
                    class="align-self-center"
                  />
                </tm-calendar-month-day-layout>
              </tm-calendar-cell>
            </tm-calendar-row>
          </tm-calendar-body>
        </tm-calendar-grid>
      </div>
    </tm-scrollbar>
  </div>
</template>

<script setup lang="ts">
import TmCalendarGrid from '@/components/shared/calendar/grid/TmCalendarGrid.vue'
import TmCalendarBody from '@/components/shared/calendar/grid/TmCalendarBody.vue'
import TmCalendarRow from '@/components/shared/calendar/grid/TmCalendarRow.vue'
import TmCalendarCell from '@/components/shared/calendar/grid/TmCalendarCell.vue'
import TmScrollbar from '@/components/shared/TmScrollbar.vue'
import { provide } from '@/composition/vue/compositionApi'
import { CalendarScrollHiddenSymbol } from '@/components/shared/calendar/types'
import TmCalendarMonthDayLayout from '@/components/shared/calendar/header/TmCalendarMonthDayLayout.vue'
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'
import { randomNumber } from '@/utils/number'
import TmSkeletonFilters from '@/components/shared/skeletons/TmSkeletonFilters.vue'

provide(CalendarScrollHiddenSymbol, true)
</script>

<style lang="scss" scoped>
.tm-calendar {
  height: 100%;
  display: flex;
  flex-direction: column;

  &__body {
    flex-grow: 1;
  }

  &-monthly {
    min-width: 600px;
  }
}

.tm-calendar-monthly-row {
  min-height: 90px;
  max-height: 100px;
  flex: 1 0 0;

  &__cell {
    flex: 1 0 0;
    padding: 6px 4px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    &--loading {
      justify-content: center;
    }
  }

  &__skeletons {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 40px;
    gap: 8px;
  }

  &__event-group-wrapper {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
    margin-top: 4px;
  }

  &__event-group {
    min-height: auto;
  }
}
</style>
